import { render, staticRenderFns } from "./safHeaManagePolicy.vue?vue&type=template&id=504551dc"
import script from "./safHeaManagePolicy.vue?vue&type=script&lang=js"
export * from "./safHeaManagePolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('504551dc')) {
      api.createRecord('504551dc', component.options)
    } else {
      api.reload('504551dc', component.options)
    }
    module.hot.accept("./safHeaManagePolicy.vue?vue&type=template&id=504551dc", function () {
      api.rerender('504551dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/shm/safHeaManagePolicy.vue"
export default component.exports